import { useTranslation } from 'react-i18next';
import Separator from 'components/Separator/Separator';

import Panel from '../../../components/Panel/Panel';
import { IRO_QUESTIONS } from '../../../constants/materialAssessment';
import MAIROImpactQuestions from './components/MAIROImpactQuestions';
import MAIROQuestionHeader from './components/MAIROQuestionHeader';
import MAIRORisksOrOpportQuestions from './components/MAIRORisksOrOpportQuestions';

import type { IMAIroQuestionViewProps } from './interfaces/IMAIroQuestionsViewProps';

import styles from './scss/MAIROQuestion.module.scss';

function MAIROQuestionView({
  data,
  control,
  currentStep,
  onNextStep,
  onPrevStep,
  onOpenReasonModal,
  setValue,
  fields,
  isReasonModalOpen,
  isIroQuestionnaireCompleted,
  handleOpenFinishModal,
  hideThirdStep,
  handleHideThirdStep,
}: IMAIroQuestionViewProps) {
  const { t } = useTranslation();

  return (
    isIroQuestionnaireCompleted ? (
      <div className={styles.finished}>
        <p>{t('materialityAssessment.complete')}</p>
      </div>
    ) : (
      <div className={styles.container}>
        <Panel className={styles.panel}>
          <MAIROQuestionHeader
            title={data?.title || ''}
            description={data?.description || ''}
            descriptionKey={t('materialityAssessment.descriptionKey')}
            valueChainSection={data?.valueChainSection || ''}
          />
          <Separator />
          {data?.questionnaireType === IRO_QUESTIONS.IMPACT ? (
            <MAIROImpactQuestions
              questions={data.questions}
              fields={fields}
              control={control}
              currentStep={currentStep}
              onNextStep={onNextStep}
              onPrevStep={onPrevStep}
              setValue={setValue}
              onOpenReasonModal={onOpenReasonModal}
              isReasonModalOpen={isReasonModalOpen}
              handleOpenFinishModal={handleOpenFinishModal}
              hideThirdStep={hideThirdStep}
              handleHideThirdStep={handleHideThirdStep}
            />
          ) : (
            <MAIRORisksOrOpportQuestions
              questions={data?.questions}
              control={control}
              setValue={setValue}
              handleOpenFinishModal={handleOpenFinishModal}
            />
          )}
        </Panel>
      </div>
    )
  );
}

export default MAIROQuestionView;
